import { createSlice } from '@reduxjs/toolkit';
export const business = createSlice({
  name: 'business',
  initialState: {
    BranchWithShowType: [],
    Title: "",
    token: "",
    phone: "",
    logo: "",
    hasWallet: false
  },
  reducers: {
    setBusiness: (state, action) => {
      return {
        ...state,
        BranchWithShowType: action.payload.BranchWithShowType,
        Title: action.payload.Title,
        token: action.payload.token,
        phone: action.payload.phone,
        logo: action.payload.logo,
        hasWallet: action.payload.hasWallet
      }
    },
  }
});

export const { setBusiness } = business.actions;

export default business.reducer;
